import { Reveal } from "../Reveal";
import { Zap, Layers, Tag, ShieldCheck } from "lucide-react";

const CAPABILITIES = [
  {
    no: "01",
    title: "Quick Sampling",
    body: "Concept to first pair in as little as 10–14 days. Our sample room is wired into the workshop floor, so feedback loops are tight and turnarounds short.",
    Icon: Zap,
  },
  {
    no: "02",
    title: "Small MOQs",
    body: "Built for boutiques and emerging brands — start with as few as 100 pairs per style. Test the market before committing to scale.",
    Icon: Layers,
  },
  {
    no: "03",
    title: "Private Label Ready",
    body: "Your brand, your tag, your box. End-to-end private label execution including custom hardware, lining, packaging and dust bags.",
    Icon: Tag,
  },
  {
    no: "04",
    title: "Quality, Sworn",
    body: "Goodyear welted construction, true moccasin stitching and full-grain leather sourcing — inspected pair by pair before they sail.",
    Icon: ShieldCheck,
  },
];

export const Capabilities = () => {
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative py-24 md:py-40 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-24">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="text-[11px] tracking-[0.3em] uppercase text-[#B8945F] font-medium">
                02 — Capabilities
              </span>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={100}>
              <h2
                data-testid="capabilities-heading"
                className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#0F1B3D] leading-[1.05] tracking-tight"
              >
                Built for the way modern <em className="font-light">brands</em> source.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-6 max-w-xl text-[15px] md:text-base text-[#1A1A1A]/70 leading-relaxed">
                We exist for online founders, boutique buyers and private labels who need craftsmanship without compromise — at volumes that respect the realities of independent retail.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Capability grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0F1B3D]/10">
          {CAPABILITIES.map((cap, idx) => (
            <Reveal key={cap.no} delay={idx * 80} className="bg-[#F9F8F6]">
              <div
                data-testid={`capability-card-${cap.no}`}
                className="group relative p-10 md:p-12 lg:p-14 h-full hover:bg-[#0F1B3D] hover:text-[#F9F8F6] transition-colors duration-700"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-serif text-5xl text-[#B8945F] group-hover:text-[#B8945F] transition-colors duration-700">
                    {cap.no}
                  </span>
                  <cap.Icon
                    className="w-6 h-6 text-[#0F1B3D] group-hover:text-[#B8945F] transition-colors duration-700"
                    strokeWidth={1.25}
                  />
                </div>
                <h3 className="font-serif text-3xl md:text-4xl text-current mb-4 tracking-tight">
                  {cap.title}
                </h3>
                <p className="text-[14px] md:text-[15px] leading-relaxed text-current/75 max-w-md">
                  {cap.body}
                </p>
                <div className="mt-8 h-px w-12 bg-[#B8945F] group-hover:w-24 transition-all duration-700" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
